import { c as _c } from "react/compiler-runtime";
export const MerchantListEmpty = t0 => {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <p className="flex min-h-240 items-center justify-center px-20 font-500 text-Gray-500 typo-body4">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};